import { getFirstPropertyIndexOfActivePage } from "./getFirstPropertyIndexOfActivePage";
import { getLastPropertyPositionOfActivePage } from "./getLastPropertyPositionOfActivePage";
export var getPropertySearchResultsToDisplay = function getPropertySearchResultsToDisplay(activePage, properties) {
  return properties.slice(getFirstPropertyIndexOfActivePage(activePage), getLastPropertyPositionOfActivePage(activePage));
};